import baseRest from './_baseRest.js';

/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = baseRest;

export default castRest;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_castRest.js
// module id = 1202
// module chunks = 0